import {Variable} from "@/models/variable.model";
import axios from "axios";

export async function allVariables(prjid: string): Promise<Variable[]> {
  try {
    const result = await axios.get(`/variable/all/${prjid}`)
    return result ? result.data : []
  } catch (e) {
    console.log('Failed allVariables', e)
    return []
  }
}

export async function setVariable(prjid: string, name: string, value: string, password: boolean | undefined): Promise<Variable | null> {
  try {
    const result = await axios.post(`/variable/set/${prjid}`, {name, value, password})
    return result ? result.data : null
  } catch (e) {
    console.log('Failed setVariable', e)
    return null
  }
}

export async function deleteVariable(varid: string): Promise<boolean> {
  try {
    const result = await axios.delete(`/variable/${varid}`)
    return result && result.status === 200
  } catch (e) {
    console.log('Failed allVariables', e)
    return false
  }
}

